import { UiFormFieldBuilderModule } from '@digipay/ui-form-field-builder';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ChangeDetectionStrategy, Component, effect, inject, input, OnInit, output } from '@angular/core';
import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'wealth-applet-wallet-amount-form',
  standalone: true,
  imports: [ReactiveFormsModule, UiFormFieldBuilderModule, PipesModule],
  templateUrl: './wallet-amount-form.component.html',
  styleUrl: './wallet-amount-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletAmountFormComponent extends BaseComponent implements OnInit {
  formBuilder = inject(FormBuilder);

  title = input<string | undefined>(undefined);
  amount = input<string | undefined>(undefined);
  type = input.required<'cashIn' | 'cashOut'>();
  minAmount = input<number>();
  maxAmount = input<number>();
  form: FormGroup;
  amountChange = output<{ value: string; valid: boolean }>();

  constructor() {
    super();

    effect(
      () => {
        this.updateAmount();
      },
      {
        allowSignalWrites: true,
      },
    );
  }

  private updateAmount() {
    this.form.controls['amount'].setValue(this.amount(), { emitEvent: false });
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      amount: [],
    });
    this.form.controls['amount'].valueChanges.pipe(takeUntil(this.destroyObservable)).subscribe(() => {
      this.amountChanged();
    });
    if (this.amount()) {
      this.form.controls['amount'].setValue(this.amount(), { emitEvent: false });
    }
  }

  amountChanged() {
    this.amountChange.emit({ value: this.form.controls['amount'].value, valid: this.isValid() });
  }

  private isValid() {
    return this.form.controls['amount'].value <= this.maxAmount() && this.form.controls['amount'].value >= this.minAmount();
  }
}
